import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/airworthiness-directives/")({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
